import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-457ce9d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-flex-column" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-jc-center not-found--img-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/not-found.png",
    class: "not-found--img"
  })
], -1))
const _hoisted_3 = { class: "p-d-flex p-jc-center not-found--text-container" }
const _hoisted_4 = { class: "not-found--text" }
const _hoisted_5 = { class: "p-d-flex p-jc-center not-found--text-second-container" }
const _hoisted_6 = { class: "not-found--text-second" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_header = _resolveComponent("base-header")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_base_footer = _resolveComponent("base-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_header, { type: "white" }),
    _createElementVNode("main", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_i18n_t, { keypath: "common.pageNotFound" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_i18n_t, { keypath: "common.pageNotExist" })
        ])
      ])
    ]),
    _createVNode(_component_base_footer)
  ], 64))
}